import { GET_ELECTRONIC_DOCS_PAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type GetElectronicDocumentsPageParams = {
  ids: string;
  states?: string;
  page?: number;
  size?: number;
};

const DEFAULT_PARAMS = {
  states: "",
  page: 0,
  size: 50,
};

export type ElectronicDocumentType = {
  id: number;
  code: string;
  name: string;
};

export type ElectronicDocumentProvider = {
  id: number;
  code: string;
  employerIdNumber: string;
  name: string;
};

export type ElectronicDocumentState = {
  id: number;
  code: string;
  name: string;
};

export type ElectronicDocumentUser = {
  id: string;
  name: string;
};

export type ElectronicDocumentActivityStatus = {
  id: number;
  code: string;
  name: string;
};

export type ElectronicDocumentItem = {
  id: number;
  documentNumber: string;
  type: ElectronicDocumentType;
  issuedAt: string;
  receivedAt: string;
  provider: ElectronicDocumentProvider;
  totalValue: number;
  state: ElectronicDocumentState;
  users: ElectronicDocumentUser[];
  currentUser: any;
  filingNumber: string;
  stateName: string;
  activityStatus: ElectronicDocumentActivityStatus;
  resolution: string;
  uniqueCodeElectronicBilling: string;
  applicationStatus: any;
  isFinancialProcess: boolean;
  acceptedConsolidatedValue: number;
  sustainedConsolidatedValue: number;
  consolidatedInNoAgreementValue: number;
  auditorName?: string;
};

export type GetElectronicDocumentsPageResponse = {
  content: ElectronicDocumentItem[];
  totalElements: number;
  number: number;
  size: number;
  contentSize: number;
};

export const getElectronicDocumentsPage = async (
  params: GetElectronicDocumentsPageParams,
): Promise<GetElectronicDocumentsPageResponse> => {
  const response = await apiInstance.get<GetElectronicDocumentsPageResponse>(
    GET_ELECTRONIC_DOCS_PAGE,
    {
      params: {
        states: params.states ?? DEFAULT_PARAMS.states,
        ids: params.ids,
        page: params.page ?? DEFAULT_PARAMS.page,
        size: params.size ?? DEFAULT_PARAMS.size,
      },
    },
  );
  return response.data;
};
